import { yupResolver } from "@hookform/resolvers/yup";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import LabReportBasicInformation from "./LabReportBasicInformation";
import LabReportHeader from "./LabReportHeader";
import { LabTestAPI } from "api";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";

const schema = yup.object({
  labTests: yup.array().of(
    yup.object({
      testName: yup.string(),
      testDate: yup.string(),
      results: yup.string(),
      normalRange: yup.string(),
      notes: yup.string(),
      fileName: yup.string(),
      filePath: yup.string(),
    })
  ),
});

const AddLabReport = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      labTests: [{}],
    },
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let patientId =
      location.state && !location.state.parentId1
        ? location.state?.patientId
        : location.state?.parentId1;

    let myData = {
      ...data,
      labTests: (data.labTests || []).map((item) => ({
        ...item,
        patientId: patientId,
        fileName: item.fileName ?? "",
        filePath: item.filePath ?? "",
      })),
    };

    console.log(myData.labTests);

    if (!location.state.patientId) {
      toast.error("Please add Patient first", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      return;
    }

    // console.log(myData);

    try {
      await LabTestAPI.post(myData.labTests);
      toast.success("Record updated successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }

    // {
    //   myData.id = location?.state ? location?.state?.id : 0;
    //   myData.library = 0;
    //   myData.phone = "";
    //   myData.email = "";
    //   myData.logo = "";
    //   myData.level = "";
    //   myData.strength = "";
    // }
  };

  // useEffect(() => {
  //   if (location.state) {
  //     reset(location.state);
  //   }
  // }, []);

  return (
    <>
      <div className="py-2">
        <BreadCrumb />
      </div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">
            <Col xs={12}>
              <LabReportHeader />
            </Col>
            <Col lg={12}>
              <LabReportBasicInformation />
              {/* <ProductUpload /> */}
              {/* <ProductDetails /> */}
              {/* <ProductSpecifications /> */}
            </Col>
            {/* <Col xs={12}>
              <CategoryFooter />
            </Col> */}
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddLabReport;
